import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofPopup } from './components/SocialProofPopup';
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const CauseSection = lazy(() => import('./components/CauseSection').then(m => ({
  default: m.CauseSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const ValueSection = lazy(() => import('./components/ValueSection').then(m => ({
  default: m.ValueSection
})));
const PurchaseSection = lazy(() => import('./components/PurchaseSection').then(m => ({
  default: m.PurchaseSection
})));
const ForWhomSection = lazy(() => import('./components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1272607964501807');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-warm-white font-sans selection:bg-sky/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <PainSection data-id="element-3" />
        <CauseSection data-id="element-4" />
        <MethodSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <IncludesSection data-id="element-7" />
        <ValueSection data-id="element-8" />
        <PurchaseSection data-id="element-9" />
        <ForWhomSection data-id="element-10" />
        <FAQSection data-id="element-11" />

        <FooterSection data-id="element-12" />
      </Suspense>
      <SocialProofPopup data-id="element-13" />
    </div>;
}